<template>
    <div class="bg-gray-100 h-24 xl:h-20 relative flex items-center">
        <div class="w-full px-4 xl:container xl:px-0 flex items-center justify-between">
            <section class="flex items-center justify-between w-full xl:hidden">
                <div>
                    <img src="/images/miami-realtor-banner.png" width="107" />
                    <p class="text-title-lg font-bold text-gray-900">20% OFF</p>
                </div>
                <div class="flex justify-end">
                    <div class="relative z-40 flex flex-col items-end">
                        <AppButton
                            id="miamirealtors-banner-see-plans"
                            class="bg-gray-900 relative z-40"
                            @click="handleNavigateToMiami"
                            size="sm"
                        >
                            See Plans
                        </AppButton>
                        <p class="text-gray-950 text-body-sm mt-2">Exclusively for MIAMI Realtors!</p>
                    </div>
                    <img
                        src="/images/miami-banner-colors-mobile.png"
                        class="absolute bottom-0 right-0 object-cover blur-sm z-0 h-24"
                    />
                </div>
            </section>
            <div class="hidden xl:flex items-center justify-between w-full">
                <img src="/images/miami-realtor-banner.png" height="60" />
                <div class="text-center">
                    <p class="text-[44px] text-gray-900 mb-0">20% OFF</p>
                    <p class="text-gray-950 font-bold text-center relative bottom-2">Exclusively for MIAMI Realtors!</p>
                </div>
                <AppButton
                    id="miamirealtors-banner-see-plans"
                    class="bg-gray-900 relative z-40"
                    @click="handleNavigateToMiami"
                >
                    See Plans
                </AppButton>
                <img src="/images/miami-banner-colors.png" class="absolute right-0 bottom-0 h-20" height="80" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const handleNavigateToMiami = () => {
    return navigateTo("/miamirealtors");
};
</script>

<style scoped></style>
